import React, { useState, useEffect, useMemo } from "react";
import { EyeOutlined } from "@ant-design/icons";
import {
  Layout,
  theme,
  ConfigProvider,
  FloatButton,
  Input,
  Row,
  Form,
  Typography,
  Checkbox,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Breadcrumb,
  Button,
} from "antd";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import tableData from "../../../config/data/dummy_data/teller-operations/linkUserToTill.json";
import FloatButtonComp from "../../../components/FloatButtonComp";
import { useNavigate } from "react-router-dom";
import { BOM } from "../../../services/definedMethod";

import TableStatus from "../../../config/data/TableViewStatus.json";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import { connect, useDispatch } from "react-redux";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import TopContent from "../../../components/layouts/TopContent";

const { Text, Link, Title } = Typography;
const Search = Input;
const { manageSalesTransactionItems, monthList } = staticConfig;

const LinkUserToTillTellerConfig = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [tellerList, setTellerList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();

  const columns = [
    {
      title: " Branch ",
      dataIndex: "vaultId",
      // dataIndex: "vaultsbranch",
    },
    {
      title: "Till Name",
      dataIndex: "description",
      // dataIndex: "tillName",
    },

    {
      title: "Denom. Tracking",
      dataIndex: "allowDenomTracking",
      // dataIndex: "denomTracking",
    },
    {
      title: "Print Receipt",
      dataIndex: "printTransactionReceipt",
      // dataIndex: "printReceipt",
    },
    {
      title: "Allow Reversal",
      dataIndex: "allowTransactionReversal",
      // dataIndex: "allowReversal",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EyeOutlined style={{ color: "black" }} />}
          onClick={() =>
            navigate("/tlo0100/till", { state: { id: record.id } })
          }
        />
      ),
    },
  ];
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value?.toLowerCase();
    // console.log(searchKey);

    if (!searchKey) {
      setTellerList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.accountNo?.toLowerCase()?.includes(searchKey.toLowerCase()),
    );
    setTellerList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }
  //END METHODS DECLARED
  useEffect(() => {
    //DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    // rightAction(cnt.RIGHT_ADD_BTN);

    getChequeDeposit();
  }, []);

  const getChequeDeposit = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.Tellerconfig, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        console.log(res);
        let tempCodeList = [];
        objList.forEach((element) => {
          tempCodeList.push({
            key: element?.id,
            id: element?.id,
            vaultId: element?.vaultId.operationId2.officeId.name,
            description: element?.description,
            allowDenomTracking: element?.allowDenomTracking ? "True" : "False",
            printTransactionReceipt: element?.printTransactionReceipt
              ? "True"
              : "False",
            allowTransactionReversal: element?.allowTransactionReversal
              ? "True"
              : "False",
          });
        });

        setTellerList(tempCodeList);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempCodeList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-tlo0100", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true} onView={handleOnView}>
      <TopContent
        pageTitle={labelConfig.manageLinkUserToTill}
        pageItems={staticConfig.manageLinkUserToTillItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Filter by name/external ID..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={tellerList}
              columns={columns}
              fileName={"Till List"}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={tellerList}
            bordered
            pagination={{
              position: ["bottomCenter"],
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LinkUserToTillTellerConfig);
